import { render, staticRenderFns } from "./foreverVip.vue?vue&type=template&id=0d5f6dfa&scoped=true"
import script from "./foreverVip.vue?vue&type=script&lang=js"
export * from "./foreverVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f6dfa",
  null
  
)

export default component.exports